export type TrialProgressionColor = 'blue' | 'yellow' | 'orange' | 'red';

export function daysBetween(fromIso: string | null | undefined, toDate: Date = new Date()): number | null {
  if (!fromIso) return null;
  const target = new Date(fromIso);
  if (Number.isNaN(target.getTime())) return null;

  const msPerDay = 86_400_000;
  const diff = target.getTime() - toDate.getTime();
  return Math.max(0, Math.ceil(diff / msPerDay));
}

export function resolveTrialColor(daysRemaining: number | null): TrialProgressionColor {
  if (daysRemaining == null) return 'blue';
  if (daysRemaining <= 0) return 'red';
  if (daysRemaining <= 2) return 'orange';
  if (daysRemaining <= 6) return 'yellow';
  return 'blue';
}

export function shouldShowUrgencyBanner(daysRemaining: number | null): boolean {
  if (daysRemaining == null) return false;
  return daysRemaining <= 2;
}
